<template>
    <b-card :style="{'max-width': get_max_width(), 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>Mark Items as Ready to Ship</h4>
        </b-card-text>

        <b-card>
            <div v-if="pull_pick_date_counts.length>0">
                <b-card-text>Pick/Pull Dates</b-card-text>
                <b-button variant="outline-primary" v-for="pull_pick_date, plidx in pull_pick_date_counts" style="margin: 5px;" @click="fetch_init(pull_pick_date)" v-bind:key="plidx">{{ pull_pick_date.date }} ({{ pull_pick_date.cnt }})</b-button>
            </div>

            <!-- <b-card-text style="text-align: center;">
                Please make sure to write <span style="background: #f2f2f2; padding: 3px;">INV/TR</span> and <span style="background: #f2f2f2; padding: 3px;">Stage for</span> label on each item. 
            </b-card-text> -->
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <div v-if="items.length > 0">
                <b-card-text v-if="selected.length > 0">
                    <b-button size="sm" variant="outline-primary" @click="update_selected">Update Selected</b-button>
                </b-card-text>
                <table style="width: 100%;">
                    <thead>
                        <tr style="background: slategray; color: white;">
                            <td class="ipt_tdhr">
                                #
                            </td>
                            <td class="ipt_tdhr">
                                PULLED AT
                            </td>
                            <td class="ipt_tdhr">
                                PICKED AT
                            </td>
                            <td class="ipt_tdhr">
                                PRD
                            </td>
                            <td class="ipt_tdhr">
                                QTY
                            </td>
                            <td class="ipt_tdhr">
                                INV/TR
                            </td>
                            <td class="ipt_tdhr">
                                STAGE FOR
                            </td>
                            <td class="ipt_tdhr">


                                ACTION
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, idx) in items" :style="{background: get_background(item)}" v-bind:key="idx">
                            <td class="ipt_tdr">
                                {{ idx + 1 }}
                            </td>
                            
                            
                            
                            <td class="ipt_tdr">
                                <div>{{ item.pulled_ts }}</div> 
                                <div>({{ item.pulled_by }})</div>
                            </td>
                            
                            <td class="ipt_tdr">
                                <div>{{ item.picked_ts }}</div> 
                                <div>({{ item.picked_by }})</div>
                            </td>

                            <td class="ipt_tdr">
                                {{ item.product_sku }}
                            </td>

                            <td class="ipt_tdr">
                                {{ item.quantity }}
                            </td>

                            <td class="ipt_tdr">
                                {{ item.invoice_id }}
                            </td>

                            <td class="ipt_tdr">
                                {{ item.stage_for }}
                            </td>

                            <td class="ipt_tdr">
                                <span v-if="item.rts_status == 'rts'">
                                    <b-button size="sm" variant="outline-danger" @click="undo_rts_action(item)">Undo RTS</b-button>
                                </span>
                                <span v-else>
                                    <b-button variant="primary" size="sm" @click="mark_rts(item)" style="margin: 3px;">Mark RTS</b-button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div v-else>
                <b-card-text style="margin-top: 10px;">
                    <b-alert variant="warning" show>No Items To Mark as Ready to Ship</b-alert>
                </b-card-text>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
   
    export default {
        name: "AdminToolsMarkItemsReadyToShip",
        props: [],
        components: {Backer, flatPickr},
        data: function(){
            return {
                items: [],
                items_being_loaded: false,
                packet: {},
                all_loc_inventory_dict: {},
                global_vars: global_vars,
                selected: [],
                pull_date_fake: null,
                pull_date: null,
                pull_location_id: null,
                pull_pick_date_counts: []
            }
        },
        methods: {
            fetch_init: function(item){
                let that = this;
                let data = {pull_pick_date: item.date};
                let path = "/api/transfers/get_items_to_mark_as_ready_to_ship/"
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading items to be marked as ready to ship.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/transfers/get_pull_pick_date_counts/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response) {
                            if (response.data.result){
                                that.pull_pick_date_counts = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error) {
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading ready to ship items summary.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            undo_rts_action: function(item){
                let path = "/api/transfers/mark_single_element_no_rts_action/"
                let that = this;
                let data = {
                    tr_id: item.tr_id,
                    product_sku: item.product_sku
                }
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Undo Raeady to Ship Action Success.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.rts_status = null

                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error undoing item as ready to ship. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            mark_rts: function(item){
                let path = "/api/transfers/mark_single_element_rts/"
                let that = this;
                let data = {
                    rts_by: this.packet.userDetails.username,
                    rts_ts: moment().format("MM-DD-YYYY HH:mm"),
                    rts_status: "rts",
                    tr_id: item.tr_id,
                    product_sku: item.product_sku
                }
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Marked as ready to ship.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.rts_status = "rts"
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error marking item as ready to ship. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            update: function(item){
                let path = "/api/transfers/update/"
                let that = this;
                let data = item;

                if (!data.stage_for){
                    this.$vex.dialog.alert({
                        message: "Please specify a staging location for the item"
                    });
                    return
                }
                if (!data.pull_date){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid pull date."
                    });
                    return
                }

                // data.pull_date = moment(data.pull_date, "YYYY-MM-DD").format('YYYY-MM-DD');
                // console.log(data.pull_date)

                data.status = this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (data.stage_for != null){
                            item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            compose_update: function(item){
                let approved_quantity = parseInt(item.approved_quantity);
                let status = item.status;
                let locsub = item.locsub;
                let source_location_id = null;
                let source_sublocation_id = null;
                if (locsub){
                    source_location_id = parseInt(locsub.split("|")[0])
                    source_sublocation_id = parseInt(locsub.split("|")[1])
                }

                let output = {out: {}, error: null};
                if (isNaN(approved_quantity)){
                    output.error = "Please specify a valid approved quantity."
                }
                output.out = {status: status, source_location_id: source_location_id, source_sublocation_id: source_sublocation_id, approved_quantity: approved_quantity, tr_id: item.tr_id, itemid: item.itemid}
                return output;
            },
            update_single_item: function(item){
                let update_item = this.compose_update(item);
                //any error
                if (update_item.error){
                    this.$vex.dialog.alert({
                        message: update_item.error
                    }); 
                    return
                }
                let data = {items: [update_item.out]}
                this.update(data)
            },
            select_all_items: function(checked){
                if (checked == true){
                    for (var i = 0; i<this.items.length; i++){
                        this.selected.push(
                            this.items[i].tr_id + '|' + this.items[i].itemid
                        )
                    }
                }
                else {
                    this.selected = []
                }
            },
            update_selected: function(e){
                if (e){
                    e.preventDefault();
                }

                if (this.selected.length <= 0){
                    return
                }
                else {
                    let that = this;
                    let selected_items = this.items.filter(function(d){ return that.selected.indexOf(d.tr_id+'|'+d.itemid) >= 0 })

                    if (selected_items.length > 0){
                        let composed = selected_items.map(function(d){ return that.compose_update(d)});
                        //any errors
                        let errors = composed.filter(function(d){ return d.error != null })
                        if (errors.length > 0){
                            this.$vex.dialog.alert({
                                message: errors[0].error
                            }); 
                            return
                        }
                        else {
                            //go and update all
                            this.update({items: composed.map(function(d){return d.out} )})
                        }
                    }
                }
            },
            get_background: function(item){
                if (item.rts_status == 'rts'){
                    return '#f1f8e9'
                }
                else {
                    return 'white'
                }
            },
            get_max_width: function(){
                return '1050px'
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        font-size: 14px;
        background: inherit;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsMarkItemsReadyToShip.vue